// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3YZJE","emails":"CreateEditClinics_emails__1EjWK","emailTagLabel":"CreateEditClinics_emailTagLabel__2NfeL"};